import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-system',
  templateUrl: './system.component.html',
  standalone: true,
  imports: [RouterModule,SidebarComponent,HeaderComponent,FooterComponent],
  styleUrls: ['./system.component.scss']
})
export class SystemComponent {

}
